// src/context/dataReducer.js

export const actionTypes = {
  // Existing Action Types

  SET_QUERY_RESULTS: 'SET_QUERY_RESULTS',
  UPDATE_QUERY_RESULTS: 'UPDATE_QUERY_RESULTS',
  SET_LAST_QUERY: 'SET_LAST_QUERY',
  SET_QUERY_TABLE_SORTING: 'SET_QUERY_TABLE_SORTING',
  SET_ACTIVE_CHANNEL_ID: 'SET_ACTIVE_CHANNEL_ID',
  SET_ACTIVE_CHANNEL: 'SET_ACTIVE_CHANNEL',
  SET_ACTIVE_INFLUENCER_AND_CHANNEL: 'SET_ACTIVE_INFLUENCER_AND_CHANNEL',
  SET_ACTIVE_STATUS: 'SET_ACTIVE_STATUS',
  SET_USER_PROFILE: 'SET_USER_PROFILE',
  SET_IS_USER_PROFILE_MODAL_OPEN: 'SET_IS_USER_PROFILE_MODAL_OPEN',
  SET_IS_USER_PROFILE_MODAL_LOADING: 'SET_IS_USER_PROFILE_MODAL_LOADING',
  SET_USER_PROFILE_MODAL_ERROR: 'SET_USER_PROFILE_MODAL_ERROR',
  SET_SOCIAL_MEDIA_CONNECTIONS: 'SET_SOCIAL_MEDIA_CONNECTIONS',
  SET_RECONNECT_NETWORK: 'SET_RECONNECT_NETWORK',
  SET_IS_OFFLINE: 'SET_IS_OFFLINE',
  SET_IS_RETRYING: 'SET_IS_RETRYING',
  SET_RETRY_FAILED: 'SET_RETRY_FAILED',

  // Billing & Wallet Types
  UPDATE_ACCOUNT_STATUS: 'UPDATE_ACCOUNT_STATUS',
  SET_SYSTEM_INVOICES: 'SET_SYSTEM_INVOICES',
  UPDATE_INVOICE_STATUS: 'UPDATE_INVOICE_STATUS',
  SET_USER_INVOICES: 'SET_USER_INVOICES',
  SET_COMPANY_WALLET_TRANSACTIONS: 'SET_COMPANY_WALLET_TRANSACTIONS',
  SET_SYSTEM_WALLET_TRANSACTIONS: 'SET_SYSTEM_WALLET_TRANSACTIONS',
  SET_AUTO_TOPUP_CONFIG: 'SET_AUTO_TOPUP_CONFIG',
  SET_AUTO_TOPUP_LOADING: 'SET_AUTO_TOPUP_LOADING',
  SET_ANALYTICS_INITIAL_TAB: 'SET_ANALYTICS_INITIAL_TAB',
  SET_STRIPE_LOADING: 'SET_STRIPE_LOADING',

  // To-Do Action Types
  ADD_TASK: 'ADD_TASK',
  TOGGLE_TASK_COMPLETION: 'TOGGLE_TASK_COMPLETION',
  DELETE_TASK: 'DELETE_TASK',
  SET_TASKS: 'SET_TASKS',
  UPDATE_TASKS_DATE: 'UPDATE_TASKS_DATE',
  SET_SELECTED_DATE: 'SET_SELECTED_DATE',
  SET_QUERY_MODE: 'SET_QUERY_MODE',
  SET_ISLOADING_QUERY_DATA: 'SET_ISLOADING_QUERY_DATA',

  // Publication Action Types
  SET_PUBLICATIONS: 'SET_PUBLICATIONS',
  SET_PUBLICATION_TOGGLING_VIDEO: 'SET_PUBLICATION_TOGGLING_VIDEO',
  SET_PUBLICATION_TOGGLING_PRODUCT: 'SET_PUBLICATION_TOGGLING_PRODUCT',
  SET_PUBLICATION_REFRESHING_METADATA: 'SET_PUBLICATION_REFRESHING_METADATA',
  UPDATE_PUBLICATION_VIDEO_DATA: 'UPDATE_PUBLICATION_VIDEO_DATA',
  UPDATE_PUBLICATION_PRODUCTS: 'UPDATE_PUBLICATION_PRODUCTS',
  UPDATE_PUBLICATION_DETAILS: 'UPDATE_PUBLICATION_DETAILS',
  SET_PUBLICATION_AI_SUMMARY: 'SET_PUBLICATION_AI_SUMMARY',
  SET_PUBLICATION_GENERATING_SUMMARY: 'SET_PUBLICATION_GENERATING_SUMMARY', // Assuming this exists
  SET_AGGREGATED_ANALYSIS_RESULTS: 'SET_AGGREGATED_ANALYSIS_RESULTS',
  SET_INDIVIDUAL_MARKET_FIT_RESULTS: 'SET_INDIVIDUAL_MARKET_FIT_RESULTS',
  SET_AGGREGATED_MARKET_FIT: 'SET_AGGREGATED_MARKET_FIT',
  SET_AGGREGATED_PUBLICATION_SUMMARY: 'SET_AGGREGATED_PUBLICATION_SUMMARY',
  CLEAR_AGGREGATED_DATA: 'CLEAR_AGGREGATED_DATA',
  SET_INDIVIDUAL_MARKET_FIT_ANALYSIS: 'SET_INDIVIDUAL_MARKET_FIT_ANALYSIS',

  // --- NEW: Smart Dashboard Analytics Action Types ---
  SET_IS_ANALYTICS_MODAL_OPEN: 'SET_IS_ANALYTICS_MODAL_OPEN',
  SET_ANALYTICS_DASHBOARD_LOADING: 'SET_ANALYTICS_DASHBOARD_LOADING',
  SET_ANALYTICS_DASHBOARD_ERROR: 'SET_ANALYTICS_DASHBOARD_ERROR',
  SET_ANALYTICS_DASHBOARD_DATA: 'SET_ANALYTICS_DASHBOARD_DATA',
  SET_LAST_ANALYTICS_QUERY: 'SET_LAST_ANALYTICS_QUERY',
  SET_ANALYTICS_SELECTED_CHART_TYPE: 'SET_ANALYTICS_SELECTED_CHART_TYPE',

  // Email Action Types
  UPDATE_EMAIL_PAGE_WORK: 'UPDATE_EMAIL_PAGE_WORK',
  CLEAR_EMAIL_PAGE_WORK: 'CLEAR_EMAIL_PAGE_WORK',

  // Company Action Types
  SET_COMPANY_MODAL_OPEN: 'SET_COMPANY_MODAL_OPEN',
  SET_COMPANY_DATA: 'SET_COMPANY_DATA',
  SET_COMPANY_MODAL_LOADING: 'SET_COMPANY_MODAL_LOADING',
  SET_COMPANY_MODAL_ERROR: 'SET_COMPANY_MODAL_ERROR',

  // Legal Action types
  SET_PENDING_AGREEMENTS: 'SET_PENDING_AGREEMENTS',

  // Discovery Action Types
  SET_ON_HOLD_INFLUENCERS: 'SET_ON_HOLD_INFLUENCERS',
  ADD_TO_ON_HOLD_INFLUENCERS: 'ADD_TO_ON_HOLD_INFLUENCERS',
  REMOVE_FROM_ON_HOLD_INFLUENCERS: 'REMOVE_FROM_ON_HOLD_INFLUENCERS',
  UPDATE_ON_HOLD_INFLUENCER: 'UPDATE_ON_HOLD_INFLUENCER',
  UPDATE_MANY_ON_HOLD_INFLUENCERS: 'UPDATE_MANY_ON_HOLD_INFLUENCERS',
  SET_DISCOVERY_SORTING: 'SET_DISCOVERY_SORTING',

  // --- NEW Market Fit Modal Action Types ---
  SET_IS_MARKET_FIT_MODAL_OPEN: 'SET_IS_MARKET_FIT_MODAL_OPEN',
  SET_MARKET_FIT_DASHBOARD_DATA: 'SET_MARKET_FIT_DASHBOARD_DATA',
  SET_IS_MARKET_FIT_DASHBOARD_LOADING: 'SET_IS_MARKET_FIT_DASHBOARD_LOADING',

  // --- NEW Content Focus Modal Action Types ---
  SET_IS_CONTENT_FOCUS_MODAL_OPEN: 'SET_IS_CONTENT_FOCUS_MODAL_OPEN',
  SET_CONTENT_FOCUS_DASHBOARD_DATA: 'SET_CONTENT_FOCUS_DASHBOARD_DATA',
  SET_IS_CONTENT_FOCUS_DASHBOARD_LOADING:
    'SET_IS_CONTENT_FOCUS_DASHBOARD_LOADING',

  // Discover Settings Action Types
  SET_IS_DISCOVERY_SETTINGS_MODAL_OPEN: 'SET_IS_DISCOVERY_SETTINGS_MODAL_OPEN',
  SET_DISCOVERY_SETTINGS_LOADING: 'SET_DISCOVERY_SETTINGS_LOADING',
  SET_DISCOVERY_SETTINGS_ERROR: 'SET_DISCOVERY_SETTINGS_ERROR',
  SET_DISCOVERY_SETTINGS: 'SET_DISCOVERY_SETTINGS',

  // Products Action Types
  SET_PRODUCTS: 'SET_PRODUCTS',
  ADD_PRODUCT: 'ADD_PRODUCT', // Add a single product to the list
  UPDATE_PRODUCT_IN_LIST: 'UPDATE_PRODUCT_IN_LIST', // Update a product in the list
  REMOVE_PRODUCT_FROM_LIST: 'REMOVE_PRODUCT_FROM_LIST', // Remove a product from the list
  SET_IS_PRODUCT_MODAL_OPEN: 'SET_IS_PRODUCT_MODAL_OPEN',
  SET_SELECTED_PRODUCT_ID: 'SET_SELECTED_PRODUCT_ID', // For the modal dropdown
  SET_PRODUCT_MODAL_LOADING: 'SET_PRODUCT_MODAL_LOADING', // Loading state for modal ops
  SET_PRODUCT_MODAL_ERROR: 'SET_PRODUCT_MODAL_ERROR', // Error state for modal ops

  // --- Config Action Types ---
  SET_TASK_TEMPLATES: 'SET_TASK_TEMPLATES',
  UPDATE_TASK_TEMPLATE_IN_LIST: 'UPDATE_TASK_TEMPLATE_IN_LIST',
  SET_LLM_CONFIGURATIONS: 'SET_LLM_CONFIGURATIONS', // For available LLMs
  SET_USER_SETTINGS: 'SET_USER_SETTINGS', // For user's default LLM
  SET_IS_LLM_CONFIG_MODAL_OPEN: 'SET_IS_LLM_CONFIG_MODAL_OPEN',
  SET_LLM_CONFIG_MODAL_LOADING: 'SET_LLM_CONFIG_MODAL_LOADING', // Specific loading for LLM modal
  SET_LLM_CONFIG_MODAL_ERROR: 'SET_LLM_CONFIG_MODAL_ERROR', // Specific error for LLM modal
  SET_ADMIN_LLM_CONFIGS: 'SET_ADMIN_LLM_CONFIGS', // Stores the full list for admin editing
  ADD_ADMIN_LLM_CONFIG: 'ADD_ADMIN_LLM_CONFIG', // Add one or more new configs to the admin list
  UPDATE_ADMIN_LLM_CONFIG: 'UPDATE_ADMIN_LLM_CONFIG', // Update a config in the admin list
  DELETE_ADMIN_LLM_CONFIG: 'DELETE_ADMIN_LLM_CONFIG', // Remove a config from the admin list
  SET_IS_LLM_ADMIN_MODAL_OPEN: 'SET_IS_LLM_ADMIN_MODAL_OPEN', // Separate modal state
  SET_LLM_ADMIN_MODAL_LOADING: 'SET_LLM_ADMIN_MODAL_LOADING', // Separate loading state
  SET_LLM_ADMIN_MODAL_ERROR: 'SET_LLM_ADMIN_MODAL_ERROR', // Separate error state

  // Chats Action types
  ADD_CHAT: 'ADD_CHAT',
  DELETE_CHAT: 'DELETE_CHAT',
  SET_CHAT_IN_PROGRESS: 'SET_CHAT_IN_PROGRESS',

  // --- NEW Admin Tasks Action Types ---
  SET_IS_ADMIN_TASKS_MODAL_OPEN: 'SET_IS_ADMIN_TASKS_MODAL_OPEN',
  SET_ADMIN_TASKS_LOADING: 'SET_ADMIN_TASKS_LOADING',
  SET_ADMIN_TASKS_ERROR: 'SET_ADMIN_TASKS_ERROR',
  SET_ALL_USERS: 'SET_ALL_USERS', // For the list of all users
  ADD_USER_TO_ALL_USERS_LIST: 'ADD_USER_TO_ALL_USERS_LIST', // Add a new user after admin signup
  REMOVE_USER_FROM_ALL_USERS_LIST: 'REMOVE_USER_FROM_ALL_USERS_LIST', // Remove a user after admin deletion

  // --- AI Chat Action Types ---
  SET_AI_CHATS: 'SET_AI_CHATS',
  ADD_AI_CHAT: 'ADD_AI_CHAT',
  REMOVE_AI_CHAT: 'REMOVE_AI_CHAT',
  UPDATE_AI_CHAT_TITLE: 'UPDATE_AI_CHAT_TITLE',

  // Spinner for loading content on the screen
  SET_LOADING: 'SET_LOADING',

  //Global Error state management action types
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
  SET_API_ERROR: 'SET_API_ERROR',
  CLEAR_API_ERROR: 'CLEAR_API_ERROR',

  //Token states
  SET_META_TOKEN_EXPIRED: 'SET_META_TOKEN_EXPIRED',

  // --- NEW: AI Agent Page Cache ---
  UPDATE_AI_AGENT_PAGE_CACHE: 'UPDATE_AI_AGENT_PAGE_CACHE',
  CLEAR_AI_AGENT_PAGE_CACHE: 'CLEAR_AI_AGENT_PAGE_CACHE',

  // --- NEW SuperAdmin Action Types ---
  SET_IS_SUPERADMIN_MODAL_OPEN: 'SET_IS_SUPERADMIN_MODAL_OPEN',
  SET_SUPERADMIN_LOADING: 'SET_SUPERADMIN_LOADING',
  SET_SUPERADMIN_ERROR: 'SET_SUPERADMIN_ERROR',
  SET_SYSTEM_USERS: 'SET_SYSTEM_USERS',
};

export const dataReducer = (state, action) => {
  switch (action.type) {
    // Existing Cases
    case actionTypes.SET_QUERY_RESULTS:
      return { ...state, queryResults: action.payload };
    // --- NEW CASE TO HANDLE THE UPDATER FUNCTION ---
    case actionTypes.UPDATE_QUERY_RESULTS: {
      // The payload is the updater function, e.g., (prevResults => ...)
      const updaterFn = action.payload;
      // The reducer has access to the current state, so we can call the function safely
      const newQueryResults = updaterFn(state.queryResults);
      return { ...state, queryResults: newQueryResults };
    }
    case actionTypes.SET_LAST_QUERY:
      return { ...state, lastQuery: action.payload };
    case actionTypes.SET_QUERY_TABLE_SORTING: {
      const updater = action.payload;
      // Check if the payload is an updater function
      const newSortingState =
        typeof updater === 'function'
          ? updater(state.queryTableSorting) // If so, call it with the current state
          : updater; // Otherwise, use the payload as the new state

      return { ...state, queryTableSorting: newSortingState };
    }
    case actionTypes.SET_ACTIVE_CHANNEL_ID:
      return { ...state, activeinfluencerId: action.payload };
    case actionTypes.SET_ACTIVE_CHANNEL: {
      // Find the influencer in queryResults and update their channel
      const updatedResults = state.queryResults.map((influencer) => {
        if (influencer.influencerId === action.payload.influencerId) {
          return {
            ...influencer,
            activeInfluencerChannel: action.payload.channel,
          };
        }
        return influencer;
      });
      return { ...state, queryResults: updatedResults };
    }
    case actionTypes.SET_ACTIVE_STATUS: {
      // Find the influencer in queryResults and update their status
      const updatedResults = state.queryResults.map((influencer) => {
        if (influencer.influencerId === action.payload.influencerId) {
          return { ...influencer, status: action.payload.status };
        }
        return influencer;
      });
      return { ...state, queryResults: updatedResults };
    }

    case actionTypes.SET_ACTIVE_INFLUENCER_AND_CHANNEL: {
      const { id, channel } = action.payload;
      const updatedResults = state.queryResults.map((influencer) => {
        if (influencer.influencerId === id) {
          return { ...influencer, activeInfluencerChannel: channel }; //Set the channel
        }
        return influencer;
      });
      return { ...state, activeinfluencerId: id, queryResults: updatedResults };
    }

    case actionTypes.SET_SOCIAL_MEDIA_CONNECTIONS:
      return { ...state, socialMediaConnections: action.payload };
    case actionTypes.SET_RECONNECT_NETWORK:
      return { ...state, reconnectNetwork: action.payload };
    case actionTypes.SET_IS_OFFLINE:
      return { ...state, isOffline: action.payload };
    case actionTypes.SET_IS_RETRYING:
      return { ...state, isRetrying: action.payload };
    case actionTypes.SET_RETRY_FAILED:
      return {
        ...state,
        isOffline: true, // Explicitly set offline
        isRetrying: false, // Re-enable the button
      };
    case actionTypes.SET_USER_PROFILE:
      console.log(
        'DEBUG REDUCER: SET_USER_PROFILE received payload:',
        action.payload,
      ); // <-- Log Step 7
      // Ensure the state is actually updated
      const newState = { ...state, userProfile: action.payload };
      console.log('DEBUG REDUCER: State *after* SET_USER_PROFILE:', newState); // <-- Log Step 8
      return newState;

    //  User Profile Modal States ---
    case actionTypes.SET_IS_USER_PROFILE_MODAL_OPEN:
      return { ...state, isUserProfileModalOpen: action.payload };
    case actionTypes.SET_IS_USER_PROFILE_MODAL_LOADING:
      return { ...state, isUserProfileModalLoading: action.payload };
    case actionTypes.SET_USER_PROFILE_MODAL_ERROR:
      return { ...state, userProfileModalError: action.payload };
    // --- End NEW ---

    // // Billing & Wallet Types States
    case actionTypes.UPDATE_ACCOUNT_STATUS:
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          accountStatus: action.payload.status,
          gracePeriodDaysLeft: action.payload.daysLeft,
          latestInvoiceLink: action.payload.invoiceLink,
        },
      };

    case actionTypes.SET_SYSTEM_INVOICES:
      return { ...state, systemInvoices: action.payload || [] };

    case actionTypes.UPDATE_INVOICE_STATUS: {
      const { invoiceId, newStatus, paidAt } = action.payload;
      const updatedInvoices = (state.systemInvoices || []).map((inv) =>
        inv.invoiceId === invoiceId
          ? { ...inv, status: newStatus, paid_at: paidAt }
          : inv,
      );
      return { ...state, systemInvoices: updatedInvoices };
    }

    case actionTypes.SET_USER_INVOICES:
      return { ...state, userInvoices: action.payload || [] };

    case actionTypes.SET_COMPANY_WALLET_TRANSACTIONS:
      return { ...state, companyWalletTransactions: action.payload || [] };

    case actionTypes.SET_SYSTEM_WALLET_TRANSACTIONS:
      return { ...state, systemWalletTransactions: action.payload || [] };

    case actionTypes.SET_AUTO_TOPUP_CONFIG:
      return { ...state, autoTopupConfig: action.payload };

    case actionTypes.SET_AUTO_TOPUP_LOADING:
      return { ...state, autoTopupLoading: action.payload };

    case actionTypes.SET_ANALYTICS_INITIAL_TAB:
      return { ...state, analyticsInitialTab: action.payload };

    case actionTypes.SET_STRIPE_LOADING:
      return { ...state, isStripeLoading: action.payload };

    // To-Do Cases
    case actionTypes.SET_TASKS:
      return { ...state, tasks: action.payload };
    case actionTypes.ADD_TASK:
      return { ...state, tasks: [action.payload, ...state.tasks] };
    case actionTypes.TOGGLE_TASK_COMPLETION:
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task.id === action.payload
            ? { ...task, completed: !task.completed }
            : task,
        ),
      };
    case actionTypes.UPDATE_TASKS_DATE: {
      const { todoIds, newDate } = action.payload; // todoIds is a Set
      if (!todoIds || !newDate) return state;

      const updatedTasks = state.tasks.map((task) => {
        if (todoIds.has(task.id)) {
          // Found a task to update, return a new object
          return { ...task, date: newDate };
        }
        // Not a task to update, return the original
        return task;
      });

      return { ...state, tasks: updatedTasks };
    }
    case actionTypes.DELETE_TASK:
      return {
        ...state,
        tasks: state.tasks.filter((task) => task.id !== action.payload),
      };
    case actionTypes.SET_SELECTED_DATE:
      return { ...state, selectedDate: action.payload };
    case actionTypes.SET_QUERY_MODE:
      return { ...state, isQueryMode: action.payload };
    case actionTypes.SET_ISLOADING_QUERY_DATA:
      if (state.isLoadingQueryData === action.payload) {
        console.warn(
          `[DataReducer] Attempted to set isLoadingQueryData to the same value: ${action.payload}`,
        );
        return state;
      }
      return { ...state, isLoadingQueryData: action.payload };

    // Publication Cases
    case actionTypes.SET_PUBLICATIONS: {
      const pubsWithDefaults = (action.payload || []).map((pub) => ({
        ...pub,
        hasAiSummary: pub.hasAiSummary !== undefined ? pub.hasAiSummary : false,
        aiSummary: pub.aiSummary || null,
        isGeneratingSummary: pub.isGeneratingSummary || false,
        isTogglingVideo: pub.isTogglingVideo || false,
        isTogglingProduct: pub.isTogglingProduct || null,
      }));
      return { ...state, publications: pubsWithDefaults };
    }

    // --- HIGHLIGHT: Modify SET_PUBLICATION_AI_SUMMARY to handle individual and batch updates ---
    case actionTypes.SET_PUBLICATION_AI_SUMMARY: {
      console.log(
        '[DEBUG 5. Reducer] Payload received for SET_PUBLICATION_AI_SUMMARY:',
        action.payload,
      );
      if (Array.isArray(action.payload)) {
        // BATCH UPDATE from background job (This part is already correct)
        const resultMap = action.payload.reduce((acc, item) => {
          acc[item.videoId] = item.analysis;
          return acc;
        }, {});

        return {
          ...state,
          publications: state.publications.map((pub) => {
            if (resultMap.hasOwnProperty(pub.videoId)) {
              const analysisResult = resultMap[pub.videoId];
              if (analysisResult && !analysisResult.failure_reason) {
                return {
                  ...pub,
                  aiSummary: analysisResult, // Store the full object
                  hasAiSummary: true,
                  analysisError: null,
                };
              } else {
                return {
                  ...pub,
                  aiSummary: null,
                  hasAiSummary: false,
                  analysisError:
                    analysisResult?.failure_reason || 'Analysis failed.',
                };
              }
            }
            return pub;
          }),
        };
      } else {
        // --- THIS IS THE FIX for SINGLE UPDATE ---
        const { publicationId, pubAiSummary } = action.payload; // pubAiSummary is now the full object
        return {
          ...state,
          publications: state.publications.map((pub) =>
            pub.publicationId === publicationId
              ? {
                  ...pub,
                  aiSummary: pubAiSummary, // Directly store the object
                  hasAiSummary:
                    pubAiSummary !== null && pubAiSummary !== undefined,
                  analysisError: null,
                }
              : pub,
          ),
        };
      }
    }

    case actionTypes.SET_PUBLICATION_GENERATING_SUMMARY: {
      const { publicationId, isGenerating } = action.payload;
      return {
        ...state,
        publications: state.publications.map((pub) =>
          pub.publicationId === publicationId
            ? { ...pub, isGeneratingSummary: isGenerating }
            : pub,
        ),
      };
    }

    case actionTypes.SET_PUBLICATION_TOGGLING_VIDEO: {
      const { publicationId, isToggling } = action.payload;
      return {
        ...state,
        publications: state.publications.map((pub) =>
          pub.publicationId === publicationId
            ? { ...pub, isTogglingVideo: isToggling }
            : pub,
        ),
      };
    }
    case actionTypes.UPDATE_PUBLICATION_VIDEO_DATA: {
      const { publicationId, includeVideoData } = action.payload;
      return {
        ...state,
        publications: state.publications.map((pub) =>
          pub.publicationId === publicationId
            ? {
                ...pub,
                includeVideoData: includeVideoData,
                isTogglingVideo: false, // Turn off loading on update
              }
            : pub,
        ),
      };
    }

    case actionTypes.SET_PUBLICATION_TOGGLING_PRODUCT: {
      const { publicationId, productId, isToggling } = action.payload;
      return {
        ...state,
        publications: state.publications.map((pub) =>
          pub.publicationId === publicationId
            ? {
                ...pub,
                // Store which product is being toggled, or just a general flag
                isTogglingProduct: isToggling ? productId : null,
                // Optionally a general flag: isTogglingAnyProduct: isToggling
              }
            : pub,
        ),
      };
    }

    case actionTypes.SET_PUBLICATION_REFRESHING_METADATA: {
      const { publicationId, isRefreshing } = action.payload;
      return {
        ...state,
        publications: state.publications.map((pub) =>
          pub.publicationId === publicationId
            ? { ...pub, isRefreshing: isRefreshing }
            : pub,
        ),
      };
    }

    case actionTypes.UPDATE_PUBLICATION_DETAILS: {
      const updatedPublication = action.payload;
      // Also ensure the new publication object has the default UI state properties
      const publicationWithDefaults = {
        ...updatedPublication,
        isRefreshing: false,
        isTogglingVideo: false,
        isTogglingProduct: null,
        isGeneratingSummary: false,
      };
      return {
        ...state,
        publications: state.publications.map((pub) =>
          pub.publicationId === updatedPublication.publicationId
            ? publicationWithDefaults
            : pub,
        ),
      };
    }

    case actionTypes.UPDATE_PUBLICATION_PRODUCTS: {
      const { publicationId, updatedProducts } = action.payload;
      return {
        ...state,
        publications: state.publications.map((pub) =>
          pub.publicationId === publicationId
            ? {
                ...pub,
                products: updatedProducts, // Replace with the new list from backend
                isTogglingProduct: null, // Turn off loading indicator
                // Optionally: isTogglingAnyProduct: false
              }
            : pub,
        ),
      };
    }

    case actionTypes.SET_AGGREGATED_ANALYSIS_RESULTS:
      // Payload: { aggregated_market_fit_analysis, aggregated_publication_summary }
      return {
        ...state,
        aggregatedMarketFit: action.payload.aggregated_market_fit_analysis,
        aggregatedPublicationSummary:
          action.payload.aggregated_publication_summary,
      };

    case actionTypes.SET_INDIVIDUAL_MARKET_FIT_RESULTS:
      // The payload from the job is now a MAP/OBJECT: { videoId: analysis, ... }
      // This is much simpler and more direct.
      if (
        action.payload &&
        typeof action.payload === 'object' &&
        !Array.isArray(action.payload)
      ) {
        return {
          ...state,
          // Merge the new map from the job with any existing analyses in the state
          individualMarketFitAnalysis: {
            ...state.individualMarketFitAnalysis,
            ...action.payload,
          },
        };
      } else {
        console.warn(
          'SET_INDIVIDUAL_MARKET_FIT_RESULTS received an invalid payload, resetting state.',
          action.payload,
        );
        return {
          ...state,
          individualMarketFitAnalysis: {}, // Reset if payload is wrong
        };
      }

    case actionTypes.SET_AGGREGATED_MARKET_FIT:
      return {
        ...state,
        aggregatedMarketFit: action.payload,
      };

    case actionTypes.SET_AGGREGATED_PUBLICATION_SUMMARY:
      return {
        ...state,
        aggregatedPublicationSummary: action.payload,
      };

    case actionTypes.CLEAR_AGGREGATED_DATA:
      return {
        ...state,
        aggregatedMarketFit: null,
        aggregatedPublicationSummary: null,
      };

    // --- HIGHLIGHT: New Reducer Case for a single entry ---
    case actionTypes.SET_INDIVIDUAL_MARKET_FIT_ANALYSIS: {
      const { videoId, analysis } = action.payload;
      if (!videoId) return state; // Safety check

      return {
        ...state,
        individualMarketFitAnalysis: {
          // Keep all existing analyses
          ...state.individualMarketFitAnalysis,
          // Add or overwrite the one for the specific videoId
          [videoId]: analysis,
        },
      };
    }

    // --- NEW: Smart Dashboard Analytics Cases ---
    case actionTypes.SET_IS_ANALYTICS_MODAL_OPEN:
      return {
        ...state,
        isAnalyticsModalOpen: action.payload,
        // Reset local modal state when it's closed for a clean experience next time
        analyticsDashboardError: !action.payload
          ? null
          : state.analyticsDashboardError,
        analyticsDashboardData: !action.payload
          ? null
          : state.analyticsDashboardData,
        analyticsSelectedChartType: !action.payload
          ? null
          : state.analyticsSelectedChartType,
      };
    case actionTypes.SET_ANALYTICS_DASHBOARD_LOADING:
      return { ...state, analyticsDashboardLoading: action.payload };
    case actionTypes.SET_ANALYTICS_DASHBOARD_ERROR:
      return { ...state, analyticsDashboardError: action.payload };
    case actionTypes.SET_ANALYTICS_DASHBOARD_DATA:
      return { ...state, analyticsDashboardData: action.payload };
    case actionTypes.SET_LAST_ANALYTICS_QUERY:
      // This state is persisted to localStorage via the useEffect in DataContext
      return { ...state, lastAnalyticsQuery: action.payload };
    case actionTypes.SET_ANALYTICS_SELECTED_CHART_TYPE:
      // This handles the user's manual override of the chart type
      return { ...state, analyticsSelectedChartType: action.payload };

    // Email Cases
    case actionTypes.UPDATE_EMAIL_PAGE_WORK: {
      const { influencerId, workData } = action.payload;
      if (!influencerId) return state; // Safety check

      return {
        ...state,
        emailPageCache: {
          ...state.emailPageCache,
          [influencerId]: {
            // Keep existing cached data for this influencer
            ...(state.emailPageCache[influencerId] || {}),
            // Overwrite with the new data
            ...workData,
          },
        },
      };
    }

    case actionTypes.CLEAR_EMAIL_PAGE_WORK: {
      const influencerId = action.payload;
      if (!influencerId) return state; // Safety check

      const newCache = { ...state.emailPageCache };
      delete newCache[influencerId]; // Remove the entry for the specific influencer

      return {
        ...state,
        emailPageCache: newCache,
      };
    }

    // Company Cases
    case actionTypes.SET_COMPANY_MODAL_OPEN:
      return { ...state, isCompanyModalOpen: action.payload };
    case actionTypes.SET_COMPANY_DATA:
      return { ...state, companyData: action.payload };
    case actionTypes.SET_COMPANY_MODAL_LOADING:
      return { ...state, isCompanyModalLoading: action.payload };
    case actionTypes.SET_COMPANY_MODAL_ERROR:
      return { ...state, companyModalError: action.payload };

    // Legal Cases
    case actionTypes.SET_PENDING_AGREEMENTS:
      return { ...state, pendingAgreements: action.payload || [] };

    // Discovery cases

    case actionTypes.ADD_TO_ON_HOLD_INFLUENCERS: {
      const newOnHold = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      const existingIds = new Set(state.onHoldInfluencers.map((inf) => inf.id));
      const uniqueNewOnHold = newOnHold.filter(
        (inf) => !existingIds.has(inf.id),
      );

      return {
        ...state,
        onHoldInfluencers: [...state.onHoldInfluencers, ...uniqueNewOnHold],
      };
    }

    case actionTypes.REMOVE_FROM_ON_HOLD_INFLUENCERS: {
      // Payload is an array of influencer IDs (database IDs) to remove
      const idsToRemove = new Set(action.payload);

      // Find the platformIds from the state before filtering, as they are needed to update job results
      const platformIdsToRemove = new Set(
        state.onHoldInfluencers
          .filter((inf) => idsToRemove.has(inf.id))
          .map((inf) => inf.platform_identifier),
      );

      return {
        ...state,
        // Filter the main on-hold list
        onHoldInfluencers: state.onHoldInfluencers.filter(
          (inf) => !idsToRemove.has(inf.id),
        ),
        // Also filter the on-hold list within the job results for UI consistency
        discoveryJob: {
          ...state.discoveryJob,
          results: {
            ...state.discoveryJob?.results,
            onHoldInfluencers:
              state.discoveryJob?.results?.onHoldInfluencers?.filter(
                (inf) => !platformIdsToRemove.has(inf.platformId),
              ) || [],
          },
        },
      };
    }

    case actionTypes.SET_ON_HOLD_INFLUENCERS:
      return {
        ...state,
        onHoldInfluencers: action.payload || [],
      };

    case actionTypes.UPDATE_ON_HOLD_INFLUENCER: {
      // Payload is the updated influencer object, which must include the 'id'
      const updatedInfluencer = action.payload;
      if (!updatedInfluencer || !updatedInfluencer.id) return state;

      return {
        ...state,
        onHoldInfluencers: state.onHoldInfluencers.map((inf) =>
          inf.id === updatedInfluencer.id ? updatedInfluencer : inf,
        ),
      };
    }
    case actionTypes.UPDATE_MANY_ON_HOLD_INFLUENCERS: {
      // Payload is an array of updated influencer objects.
      const updatedInfluencers = action.payload;
      if (
        !Array.isArray(updatedInfluencers) ||
        updatedInfluencers.length === 0
      ) {
        return state; // No changes to make
      }

      // Create a map of the updates for efficient lookup (O(n))
      const updatesMap = new Map(
        updatedInfluencers.map((inf) => [inf.id, inf]),
      );

      // Map over the existing state, replacing items found in the updatesMap (O(m))
      const newOnHoldList = state.onHoldInfluencers.map((inf) =>
        updatesMap.has(inf.id) ? updatesMap.get(inf.id) : inf,
      );

      return {
        ...state,
        onHoldInfluencers: newOnHoldList,
      };
    }

    case actionTypes.SET_DISCOVERY_SORTING: {
      const { tab, updater } = action.payload;
      // Get the current sorting for this specific tab from state
      const currentSorting = state.discoverySorting?.[tab] || [];

      // Resolve the TanStack functional updater
      const newSortingState =
        typeof updater === 'function' ? updater(currentSorting) : updater;

      return {
        ...state,
        discoverySorting: {
          ...state.discoverySorting,
          [tab]: newSortingState,
        },
      };
    }

    // Discovery Modal cases
    // --- NEW Market Fit Modal Cases ---
    case actionTypes.SET_IS_MARKET_FIT_MODAL_OPEN:
      return { ...state, isMarketFitModalOpen: action.payload };
    case actionTypes.SET_MARKET_FIT_DASHBOARD_DATA:
      return { ...state, marketFitDashboardData: action.payload };
    case actionTypes.SET_IS_MARKET_FIT_DASHBOARD_LOADING:
      return { ...state, isMarketFitDashboardLoading: action.payload };

    // --- Content Focus Modal Cases ---
    case actionTypes.SET_IS_CONTENT_FOCUS_MODAL_OPEN:
      return { ...state, isContentFocusModalOpen: action.payload };
    case actionTypes.SET_CONTENT_FOCUS_DASHBOARD_DATA:
      return { ...state, contentFocusDashboardData: action.payload };
    case actionTypes.SET_IS_CONTENT_FOCUS_DASHBOARD_LOADING:
      return { ...state, isContentFocusDashboardLoading: action.payload };

    // Discovery Settings cases
    case actionTypes.SET_IS_DISCOVERY_SETTINGS_MODAL_OPEN:
      return {
        ...state,
        isDiscoverySettingsModalOpen: action.payload,
        // Clear error when modal is opened or closed for a clean slate
        discoverySettingsError: null,
      };

    case actionTypes.SET_DISCOVERY_SETTINGS_LOADING:
      return { ...state, discoverySettingsLoading: action.payload };

    case actionTypes.SET_DISCOVERY_SETTINGS_ERROR:
      return { ...state, discoverySettingsError: action.payload };

    case actionTypes.SET_DISCOVERY_SETTINGS:
      return { ...state, discoverySettings: action.payload };

    //Product cases
    case actionTypes.SET_PRODUCTS:
      // Ensure products are sorted alphabetically by name
      const sortedProducts = [...(action.payload || [])].sort((a, b) =>
        // FIX: Provide a fallback for productName to prevent errors if it's null/undefined
        (a.productName || '').localeCompare(b.productName || ''),
      );
      return { ...state, products: sortedProducts, productModalError: null };

    case actionTypes.ADD_PRODUCT: {
      // Add new product and resort the list
      const updatedList = [...state.products, action.payload].sort((a, b) =>
        // FIX: Provide a fallback for productName
        (a.productName || '').localeCompare(b.productName || ''),
      );
      return { ...state, products: updatedList, productModalError: null };
    }

    case actionTypes.UPDATE_PRODUCT_IN_LIST: {
      // Find and update the product, then resort
      const updatedList = state.products
        .map((p) =>
          p.productsListId === action.payload.productsListId
            ? action.payload
            : p,
        )
        .sort((a, b) =>
          // FIX: Provide a fallback for productName
          (a.productName || '').localeCompare(b.productName || ''),
        );
      return { ...state, products: updatedList, productModalError: null };
    }

    case actionTypes.REMOVE_PRODUCT_FROM_LIST: {
      // Filter out the deleted product (list remains sorted)
      const updatedList = state.products.filter(
        (p) => p.productsListId !== action.payload, // Payload is the ID to remove
      );
      return { ...state, products: updatedList, productModalError: null };
    }

    case actionTypes.SET_IS_PRODUCT_MODAL_OPEN:
      // Reset selected product ID and error when opening/closing
      return {
        ...state,
        isProductModalOpen: action.payload,
        selectedProductId: action.payload ? 'new' : null, // Default to 'new' when opened
        productModalError: null, // Clear error on open/close
      };

    case actionTypes.SET_SELECTED_PRODUCT_ID:
      return {
        ...state,
        selectedProductId: action.payload,
        productModalError: null,
      }; // Clear error on selection change

    case actionTypes.SET_PRODUCT_MODAL_LOADING:
      return { ...state, isProductModalLoading: action.payload };

    case actionTypes.SET_PRODUCT_MODAL_ERROR:
      return { ...state, productModalError: action.payload };

    // --- Config Cases ---

    case actionTypes.SET_TASK_TEMPLATES:
      return {
        ...state,
        taskTemplates: action.payload || [], // Use the payload as-is. Fallback to empty array for safety.
        llmConfigModalError: null, // Clear specific modal error on refresh
      };

    case actionTypes.UPDATE_TASK_TEMPLATE_IN_LIST: {
      const updatedTemplateData = action.payload;
      if (!updatedTemplateData?.taskType) return state;

      const updatedList = (state.taskTemplates || []).map((tmpl) =>
        tmpl.taskType === updatedTemplateData.taskType
          ? { ...tmpl, ...updatedTemplateData }
          : tmpl,
      );

      return {
        ...state,
        taskTemplates: updatedList,
        llmConfigModalError: null,
      };
    }

    case actionTypes.SET_LLM_CONFIGURATIONS:
      return { ...state, llmConfigs: action.payload || {} }; // Store grouped configs { provider: { idiom: [models] } }

    case actionTypes.SET_USER_SETTINGS:
      return {
        ...state,
        userSettings: action.payload || {
          userId: state.userProfile?.uid,
          defaultLlmConfigId: null,
        },
      }; // Ensure structure exists

    // --- LLM Config Modal Cases ---
    case actionTypes.SET_IS_LLM_CONFIG_MODAL_OPEN:
      return {
        ...state,
        isLlmConfigModalOpen: action.payload,
        llmConfigModalError: null, // Clear specific modal error when opening/closing
      };
    case actionTypes.SET_LLM_CONFIG_MODAL_LOADING:
      return { ...state, llmConfigModalLoading: action.payload };
    case actionTypes.SET_LLM_CONFIG_MODAL_ERROR:
      return { ...state, llmConfigModalError: action.payload };

    // --- Config Cases --- managed by Admin users ONLY ---
    case actionTypes.SET_ADMIN_LLM_CONFIGS:
      // Store the raw list fetched for the admin modal
      return { ...state, adminLlmConfigsList: action.payload || [] };

    case actionTypes.ADD_ADMIN_LLM_CONFIG: {
      const newConfigs = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      const updatedList = [
        ...(state.adminLlmConfigsList || []),
        ...newConfigs,
      ].sort((a, b) =>
        // FIX: Provide fallbacks for all parts of the sort key
        `${a.providerName || ''}-${a.modelName || ''}-${a.idiom || ''}`.localeCompare(
          `${b.providerName || ''}-${b.modelName || ''}-${b.idiom || ''}`,
        ),
      );
      return { ...state, adminLlmConfigsList: updatedList };
    }

    case actionTypes.UPDATE_ADMIN_LLM_CONFIG: {
      const updatedConfig = action.payload;
      if (!updatedConfig?.llmConfigId) return state;
      const updatedList = (state.adminLlmConfigsList || [])
        .map((config) =>
          config.llmConfigId === updatedConfig.llmConfigId
            ? updatedConfig
            : config,
        )
        .sort((a, b) =>
          // FIX: Provide fallbacks for all parts of the sort key
          `${a.providerName || ''}-${a.modelName || ''}-${a.idiom || ''}`.localeCompare(
            `${b.providerName || ''}-${b.modelName || ''}-${b.idiom || ''}`,
          ),
        );
      return { ...state, adminLlmConfigsList: updatedList };
    }

    case actionTypes.DELETE_ADMIN_LLM_CONFIG: {
      // Payload is the llmConfigId to delete
      const idToDelete = action.payload;
      const updatedList = (state.adminLlmConfigsList || []).filter(
        (config) => config.llmConfigId !== idToDelete,
      );
      // No need to resort after filter
      return { ...state, adminLlmConfigsList: updatedList };
    }
    case actionTypes.SET_IS_LLM_ADMIN_MODAL_OPEN:
      return {
        ...state,
        isLlmAdminModalOpen: action.payload,
        llmAdminModalError: null,
      }; // Clear admin error on open/close
    case actionTypes.SET_LLM_ADMIN_MODAL_LOADING:
      return { ...state, llmAdminModalLoading: action.payload };
    case actionTypes.SET_LLM_ADMIN_MODAL_ERROR:
      return { ...state, llmAdminModalError: action.payload };

    // Chat Cases
    case actionTypes.ADD_CHAT:
      return {
        ...state,
        chats: [...state.chats, action.payload],
      };
    case actionTypes.DELETE_CHAT:
      return {
        ...state,
        chats: state.chats.filter((c) => c.id !== action.payload),
      };
    case actionTypes.SET_CHAT_IN_PROGRESS:
      return {
        ...state,
        chatInProgress: action.payload,
      };

    // --- NEW Admin Tasks Cases ---
    case actionTypes.SET_IS_ADMIN_TASKS_MODAL_OPEN:
      return {
        ...state,
        isAdminTasksModalOpen: action.payload,
        adminTasksError: null,
      }; // Clear error on open/close
    case actionTypes.SET_ADMIN_TASKS_LOADING:
      return { ...state, isAdminTasksLoading: action.payload };
    case actionTypes.SET_ADMIN_TASKS_ERROR:
      return { ...state, adminTasksError: action.payload };
    case actionTypes.SET_ALL_USERS:
      // Assuming payload is an array of user objects { userId, userName, email, role }
      // Sort users alphabetically by userName for dropdowns
      const sortedUsers = Array.isArray(action.payload)
        ? [...action.payload].sort((a, b) =>
            (a.userName || '').localeCompare(b.userName || ''),
          )
        : [];
      return { ...state, allUsers: sortedUsers };
    case actionTypes.ADD_USER_TO_ALL_USERS_LIST: {
      // Add the new user to the list and re-sort
      const newUser = action.payload; // Expect { userId, userName, email, role }
      if (!newUser || !newUser.userId) return state;
      const updatedUsersList = [...(state.allUsers || []), newUser].sort(
        (a, b) => (a.userName || '').localeCompare(b.userName || ''),
      );
      return { ...state, allUsers: updatedUsersList };
    }
    case actionTypes.REMOVE_USER_FROM_ALL_USERS_LIST: {
      // Remove the user by userId from the list
      const userIdToRemove = action.payload; // Expect userId string
      if (!userIdToRemove) return state;
      const updatedUsersList = (state.allUsers || []).filter(
        (user) => user.userId !== userIdToRemove,
      );
      return { ...state, allUsers: updatedUsersList };
    }

    // --- AI Chat Cases ---
    case actionTypes.SET_AI_CHATS:
      console.log('DEBUG REDUCER: SET_AI_CHATS payload:', action.payload);
      // Ensure payload is an array, default to empty array if not
      const chatsToSet = Array.isArray(action.payload) ? action.payload : [];
      return { ...state, aiChats: chatsToSet };

    case actionTypes.ADD_AI_CHAT:
      console.log('DEBUG REDUCER: ADD_AI_CHAT payload:', action.payload);
      // Add new chat to the beginning of the list for recentness
      return { ...state, aiChats: [action.payload, ...state.aiChats] };

    case actionTypes.REMOVE_AI_CHAT:
      console.log(
        'DEBUG REDUCER: REMOVE_AI_CHAT payload (chatId):',
        action.payload,
      );
      return {
        ...state,
        aiChats: state.aiChats.filter((chat) => chat.chatId !== action.payload),
      };

    case actionTypes.UPDATE_AI_CHAT_TITLE: {
      console.log(
        'DEBUG REDUCER: UPDATE_AI_CHAT_TITLE payload:',
        action.payload,
      );
      const { chatId, newTitle } = action.payload;
      const updatedChats = state.aiChats.map(
        (chat) =>
          chat.chatId === chatId
            ? {
                ...chat,
                titleChat: newTitle,
                updatedAt: new Date().toISOString(),
              }
            : chat, // Update timestamp too
      );
      // Sort again after update to maintain order
      updatedChats.sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
      );
      return { ...state, aiChats: updatedChats };
    }

    // Loading
    case actionTypes.SET_LOADING:
      return { ...state, loading: action.payload };

    // Global Error Handlling
    case actionTypes.SET_ERROR:
      return { ...state, error: action.payload };
    case actionTypes.CLEAR_ERROR:
      return { ...state, error: null };
    case actionTypes.SET_API_ERROR: // Optional
      return {
        ...state,
        apiErrors: {
          ...state.apiErrors,
          [action.payload.apiName]: action.payload.error,
        },
      };
    case actionTypes.CLEAR_API_ERROR: {
      // Optional
      const newApiErrors = { ...state.apiErrors };
      delete newApiErrors[action.payload];
      return { ...state, apiErrors: newApiErrors };
    }
    //Token states
    case actionTypes.SET_META_TOKEN_EXPIRED:
      return { ...state, metaTokenExpired: action.payload };

    // --- NEW: AI Agent Page Cache Logic ---
    case actionTypes.UPDATE_AI_AGENT_PAGE_CACHE: {
      // Merges new data into the existing cache object
      return {
        ...state,
        aiAgentPageCache: {
          ...state.aiAgentPageCache,
          ...action.payload,
        },
      };
    }

    case actionTypes.CLEAR_AI_AGENT_PAGE_CACHE: {
      // Resets the cache to empty
      return {
        ...state,
        aiAgentPageCache: {},
      };
    }

    // --- NEW SuperAdmin Cases ---
    case actionTypes.SET_IS_SUPERADMIN_MODAL_OPEN:
      return {
        ...state,
        isSuperAdminModalOpen: action.payload,
        superAdminError: null, // Clear error on open/close
      };
    case actionTypes.SET_SUPERADMIN_LOADING:
      return { ...state, superAdminLoading: action.payload };
    case actionTypes.SET_SUPERADMIN_ERROR:
      return { ...state, superAdminError: action.payload };
    case actionTypes.SET_SYSTEM_USERS:
      // Sort users by company name, then user name for a clean dropdown
      const sortedSystemUsers = Array.isArray(action.payload)
        ? [...action.payload].sort((a, b) => {
            const companyCompare = (a.companyName || '').localeCompare(
              b.companyName || '',
            );
            if (companyCompare !== 0) return companyCompare;
            return (a.userName || '').localeCompare(b.userName || '');
          })
        : [];
      return { ...state, systemUsers: sortedSystemUsers };

    default:
      return state;
  }
};
